import { KeyRound } from "lucide-react";
import { useLanguage } from "../i18n";

/** Area API del dealer (tab "API" nell'account): base URL, prefisso chiave e metodi v1. */
export default function DealerApiPanel({ user }) {
  const { t } = useLanguage();
  const base = process.env.REACT_APP_BACKEND_URL;
  const endpoints = [
    ["GET", "/api/dealer/v1/balance", t("dealer.epBalance")],
    ["GET", "/api/dealer/v1/catalog?country=IT", t("dealer.epCatalog")],
    ["POST", "/api/dealer/v1/orders", t("dealer.epOrders") + ' — {"package_id","customer_email","customer_name","lang"}'],
    ["GET", "/api/dealer/v1/orders/{order_id}", t("dealer.epOrderStatus")],
    ["GET", "/api/dealer/v1/sims/{iccid}", t("dealer.epSim")],
    ["POST", "/api/dealer/v1/sims/{iccid}/topups", t("dealer.epTopup") + ' — {"package_id"}'],
  ];
  return (
    <div data-testid="dealer-api-panel" className="space-y-6">
      <div className="rounded-3xl bg-[#1E293B] text-white p-7">
        <div className="flex items-center gap-2 font-mono-t text-[10px] font-bold uppercase tracking-[0.25em] text-slate-400">
          <KeyRound className="w-4 h-4 text-[#FF6B35]" /> Dealer API v1
        </div>
        <h2 className="mt-2 font-display font-extrabold text-2xl">{user?.dealer_company || user?.name}</h2>
        <div className="mt-4 grid sm:grid-cols-2 gap-3 font-mono-t text-xs">
          <div className="rounded-2xl bg-white/5 border border-white/10 p-4">
            <div className="text-slate-400 uppercase tracking-widest text-[9px] mb-1">Base URL</div>
            <div data-testid="dealer-base-url" className="break-all select-all">{base}</div>
          </div>
          <div className="rounded-2xl bg-white/5 border border-white/10 p-4">
            <div className="text-slate-400 uppercase tracking-widest text-[9px] mb-1">X-API-Key</div>
            <div data-testid="dealer-key-prefix" className="select-all">{user?.api_key_prefix || "—"}</div>
            <div className="text-slate-500 mt-1 normal-case tracking-normal">{t("dealer.keyNote")}</div>
          </div>
        </div>
      </div>
      <div className="rounded-3xl bg-white border border-slate-200/80 shadow-sm p-6 overflow-x-auto">
        <h3 className="font-display font-bold text-lg text-slate-900 mb-4">{t("dealer.methods")}</h3>
        <table className="w-full min-w-[560px] text-sm">
          <tbody>
            {endpoints.map(([m, path, desc]) => (
              <tr key={path} className="border-b border-slate-50 last:border-0">
                <td className="py-2.5 pr-3">
                  <span className={`rounded px-2 py-0.5 font-mono-t text-[10px] font-bold ${m === "GET" ? "bg-sky-50 text-sky-700" : "bg-emerald-50 text-emerald-700"}`}>{m}</span>
                </td>
                <td className="py-2.5 pr-3 font-mono-t text-xs text-slate-700">{path}</td>
                <td className="py-2.5 text-xs text-slate-500">{desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="mt-4 text-xs text-slate-400">{t("dealer.docsNote")}</p>
      </div>
    </div>
  );
}
